module.exports = __webpack_public_path__ + "img/user-admin.e30a3d76.svg";